import { render, staticRenderFns } from "./RecoveryAtIdSuccess.html?vue&type=template&id=ad161b94&scoped=true&"
import script from "./RecoveryAtIdSuccess.vue?vue&type=script&lang=js&"
export * from "./RecoveryAtIdSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryAtIdSuccess.scss?vue&type=style&index=0&id=ad161b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad161b94",
  null
  
)

export default component.exports